import styled from 'styled-components';

export const OverviewContainer = styled.div`
  background: #ffffffb2;
  border-radius: 24px;
  padding: 32px 20px 32px 32px;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;
  border: 1px solid #e2e8f099;
  margin-top: 15px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 24px;
`;

export const MainTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #212529;
  margin: 0;
  @media (max-width: 767px) {
    font-size: 26px;
  }
`;

export const SubTitle = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #6c757d;
  margin-top: 8px;
`;

export const CardsGrid = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StatCard = styled.div`
  flex: 1;
  padding: 24px;
  border-radius: 16px;
  position: relative;
  background: ${(props) => props.$gradient};
  border: 1px solid ${(props) => props.$borderColor || 'transparent'};
  min-height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  background: #ffffffcc;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;

  &::after {
    content: '';
    width: 24px;
    height: 24px;
    background-color: ${(props) => props.$iconColor};

    mask-image: url(${(props) => props.$src});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;

    -webkit-mask-image: url(${(props) => props.$src});
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
  }
`;

export const StatusDot = styled.div`
  position: absolute;
  top: 45px;
  right: 24px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.$dotColor};
`;

export const StatInfo = styled.div`
  margin-top: 12px;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 4px;
`;

export const StatValue = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: #212529;
`;
